import { conditionalMarkerSchemaEnhancer } from './markerSchemaEnhancer';

const enhanceMaplibreBlockSchema = ({ schema={}, formData={} }) => {
  // Make sure fieldsets and properties are initialized
  schema.fieldsets = schema.fieldsets || [];
  schema.properties = schema.properties || {};

  schema.properties.variation = {
    title: 'Variation',
    type: 'choice',
    choices: [
      ['default', 'Default'],
      ['counter', 'Cluster Counter'],
    ],
    default: 'default',
  };

  // Insert 'variation' into the default fieldset first
  const defaultFieldset = schema.fieldsets.find((fs) => fs.id === 'default');
  if (defaultFieldset) {
    const fields = defaultFieldset.fields.filter((f) => f !== 'variation');
    defaultFieldset.fields = ['variation', ...fields];
  }

  // Hide the Tile Style field
  schema.properties.tilesLayer.widget = "hidden";

  // Conditionally enhance the marker schema
  return conditionalMarkerSchemaEnhancer(schema, formData);
};

export default enhanceMaplibreBlockSchema;
